// eslint-disable-next-line import/prefer-default-export
export const setSaveCredentials = value => ({
    type: 'SET_SAVE_CREDENTIALS',
    value
});
